import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Tag,
  Form,
  theme,
  Select,
  Row,
  Button,
  Col,
  Input,
  DatePicker,
  Rate,
  message,
} from "antd";
import SettingBtn from "./settingBtn";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";
import FileOverview from "../material-center/fileOverview";
import AddBtn from "../material-center/add";
import { exportFn } from "../../utils/exportUtil";

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      title: "捷途山海L9功能手册",
      classification: "达人分享",
      userLevel: "KOL达人",
      carModel: "山海系列",
      tagecontentTypess: "使用攻略",
      content:
        "捷途山海L9，是捷途汽车全新打造的新能源序列首款产品，产品定位“大家庭大七座超混SUV”，搭载奇瑞鲲鹏超能混动C-DM技术，主打空间大、油耗省、动力强的产品优势，覆盖家庭旅行混动出行的使用场景。",
      starLevel: index % 5,
      allowDownload: index % 3 ? "是" : "否",
      deliveryChannel: "公域",
      time: "2025-6-20 13:20:11",
      flow: index * 105,
      createDate: "2024-11-14",
    };
  });

const CustomizationReport = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [showCols, setShowCols] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({ total: 20, dataSource: mockData });
  const [loading, setLoading] = useState(false);

  const getSettingCols = () => {
    axios
      .get(`${localhost}/manage/customColumnSetting/query`)
      .then((res) => {
        setShowCols(res?.data || []);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getSettingCols();
  }, []);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.time) {
      formData.createDateStart = moment(formData.time[0]).format("YYYY-MM-DD");
      formData.createDateEnd = moment(formData.time[1]).format("YYYY-MM-DD");
      formData.time = undefined;
    }
    axios
      .post(`${localhost}/manage/material/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
        recycleFlag: 0,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const onDelete = ({ id }) => {
    axios
      .get(`${localhost}/manage/material/delete?id=${id}`)
      .then((res) => {
        message.success("删除成功！");
        setPageInfo({ ...pageInfo, pageNo: 1 });
        getData();
      })
      .catch((error) => {
        message.error("网络异常，请重试！");
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "标题",
      dataIndex: "title",
      fixed: "left",
      key: "title",
      minWidth: 120,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "所属分类",
      dataIndex: "classification",
      key: "classification",
      minWidth: 150,
      render: (val) => <Tag color="magenta">{val}</Tag>,
    },
    {
      title: "用户分层",
      dataIndex: "userLevel",
      key: "userLevel",
      minWidth: 120,
      render: (val) => <Tag color="orange">{val}</Tag>,
    },
    {
      title: "车型解析",
      dataIndex: "carModel",
      key: "carModel",
      minWidth: 120,
      render: (val) => <Tag color="green">{val}</Tag>,
    },
    {
      title: "内容场景",
      dataIndex: "tagecontentTypess",
      key: "tagecontentTypess",
      minWidth: 120,
      render: (val) => <Tag color="purple">{val}</Tag>,
    },
    {
      title: "内容",
      dataIndex: "content",
      key: "content",
      minWidth: 120,
      render: (val) => {
        return (
          <div
            title={val}
            style={{
              maxWidth: 300,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {val}
          </div>
        );
      },
    },
    {
      title: "附件",
      dataIndex: "file",
      key: "file",
      minWidth: 100,
      render: () => <FileOverview />,
    },

    {
      title: "星级",
      dataIndex: "starLevel",
      key: "starLevel",
      minWidth: 120,
      render: (val) => <Rate disabled defaultValue={val} />,
    },

    {
      title: "是否允许下载",
      dataIndex: "allowDownload",
      key: "allowDownload",
      minWidth: 160,
      render: (val) => (val ? "是" : "否"),
    },
    {
      title: "投放渠道",
      dataIndex: "deliveryChannel",
      key: "chandeliveryChannelnel",
      minWidth: 120,
      render: (val) => (
        <Tag bordered={false} color="lime">
          {val}
        </Tag>
      ),
    },

    {
      title: "流量",
      dataIndex: "flow",
      key: "flow",
      minWidth: 120,
    },
    {
      title: "创建时间",
      dataIndex: "createDate",
      key: "createDate",
      minWidth: 120,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      unexport: true,
      minWidth: 120,
      render: (_, record) => (
        <Space size="middle">
          <AddBtn id={record.id} mode="detail" />
          <AddBtn id={record.id} mode="edit" getData={getData} />
          <a onClick={() => onDelete({ id: record.id })}>删除</a>
          <a onClick={() => onDownload([record])}>下载</a>
        </Space>
      ),
    },
  ].filter(({ title }) => (!showCols.length ? true : showCols.includes(title)));

  const onDownload = (data) => {
    console.log("下载");
    exportFn(data, columns);
  };

  return (
    <div>
      <div>
        <Form
          form={form}
          name="advanced_search"
          style={formStyle}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="title" label="标题">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="author" label="所属分类">
                <Select placeholder="请选择所属分类" allowClear>
                  <Select.Option value="t1">知识科普</Select.Option>
                  <Select.Option value="t2">活动邀请</Select.Option>
                  <Select.Option value="t3">达人分享</Select.Option>
                  <Select.Option value="t4">操作指南</Select.Option>
                  <Select.Option value="t5">问题锦囊</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="author" label="内容">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="operation" label="投放渠道">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="time" label="创建时间">
                <DatePicker.RangePicker showTime />
              </Form.Item>
            </Col>
            <Col span={8}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <div
          style={{ margin: 16, display: "flex", justifyContent: "flex-end" }}
        >
          <SettingBtn
            defaultTargetKeys={showCols}
            onChange={(keys) => {
              setShowCols(keys);
            }}
          />
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              onDownload(
                selectedRows.length ? selectedRows : dataInfo.dataSource
              );
            }}
          >
            下载报表
          </Button>
        </div>
        <Table
          rowKey="id"
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
            },
          }}
          // loading={loading}
          dataSource={dataInfo.dataSource}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default CustomizationReport;
